import { useEffect, useState } from "react";
import { Filter } from "lucide-react";
import { api } from "@/lib/api";

/** Sign-ups → sellers → 1+ listing → 3+ listings → verified → paid → first sale. */
export function FunnelCard() {
  const [d, setD] = useState(null);
  const [days, setDays] = useState(30);
  useEffect(() => { api.get("/analytics/admin/funnel", { params: { days } }).then(({ data }) => setD(data)).catch(() => {}); }, [days]);
  if (!d) return null;
  const steps = [
    ["Sign-ups", d.signups], ["Sellers", d.sellers], ["1+ listing", d.listed_1], ["3+ listings", d.listed_3],
    ["Verified ID", d.verified], ["Paid plan", d.paid], ["Can sell", d.can_sell], ["First sale", d.first_sale],
  ];
  const max = Math.max(1, d.signups);
  return (
    <div className="mt-10 rounded-xl border border-[#27272A] bg-[#121212] p-6" data-testid="funnel-card">
      <div className="flex items-center gap-2">
        <Filter className="h-4 w-4 text-[#FF9F0A]" />
        <h2 className="font-black text-xl tracking-tight">Conversion funnel</h2>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} data-testid="funnel-days" className="ml-auto h-8 rounded-md bg-[#0A0A0A] border border-[#27272A] px-2 text-xs text-white">
          {[7, 30, 90, 365].map((x) => <option key={x} value={x}>last {x} days</option>)}
        </select>
      </div>
      <p className="text-xs text-neutral-500 mt-1">The three numbers that matter: sign-ups → sellers with 3+ listings → paid plans. Enquiries in period: <span className="text-white font-mono">{d.enquiries}</span>.</p>
      <div className="mt-4 space-y-2">
        {steps.map(([label, v], i) => (
          <div key={label} className="flex items-center gap-3 text-sm" data-testid={`funnel-step-${i}`}>
            <div className="w-24 text-neutral-400 text-xs">{label}</div>
            <div className="flex-1 h-6 rounded bg-white/5 overflow-hidden"><div className="h-full rounded bg-[#FF3B30]" style={{ width: `${Math.max(2, (v / max) * 100)}%`, opacity: 0.45 + 0.55 * (1 - i / steps.length) }} /></div>
            <div className="w-16 text-right font-mono text-white">{v}</div>
            <div className="w-12 text-right text-[11px] text-neutral-500">{i === 0 ? "" : `${d.signups ? Math.round((v / d.signups) * 100) : 0}%`}</div>
          </div>
        ))}
      </div>
      <div className="mt-3 text-[11px] text-neutral-500">All time: {d.all_time.sellers} sellers · {d.all_time.verified} verified · {d.all_time.paid} on a paid plan.</div>
    </div>
  );
}
